export default "__VITE_ASSET__CNnT2EOG__"